


(function ($) {

    Drupal.behaviors.videoStage = {
        attach: function (context) {
            Drupal.behaviors.videoStageCreator(context);
        }
    }

    Drupal.behaviors.videoStageCreator = function (context) {
        
        if($(".home-teaser-stage-video").length > 0){
            
            //init video and image sources and init resize handling
            Drupal.behaviors.videoStage.handleResize();
            $(window).on("resize", Drupal.behaviors.videoStage.handleResize);
    
            //init scroll handling
            $(window).on("scroll", Drupal.behaviors.videoStage.handleScroll);
        }
    }

    Drupal.behaviors.videoStage.handleScroll = function() {
        $(".home-teaser-stage-video").each(function (index) {
        
            if($(window).scrollTop() > $(this).position().top + 20){
                if(!$(this).hasClass("scrolled")){
                    $(this).addClass("scrolled");
                    Drupal.behaviors.videoStage.handleResize();

                    $(window).off("scroll", Drupal.behaviors.videoStage.handleScroll);

                    /*
                    setTimeout(function(){
                        $(window).on("scroll", Drupal.behaviors.videoStage.handleScroll);
                    }, 500);
                    */
                }         
            }   
            /*
            else{
                if($(this).hasClass("scrolled")){
                    $(this).removeClass("scrolled");
                    Drupal.behaviors.videoStage.handleResize();

                    $(window).off("scroll", Drupal.behaviors.videoStage.handleScroll);
                    setTimeout(function(){
                        $(window).on("scroll", Drupal.behaviors.videoStage.handleScroll);
                    }, 500);
                }      
            } 
            */     
           
        });
    }

    Drupal.behaviors.videoStage.handleResize = function() {

        $(".home-teaser-stage-video").each(function (index) {
        
            //set video and image path
            var videoDesktopPath = $(this).attr("data-video-desktop");
            var videoMobilePath = $(this).attr("data-video-mobile");
            var imgDesktopPath = $(this).attr("data-image-desktop");
            var imgMobilePath = $(this).attr("data-image-mobile");

            var $video = $(this).find("video");
            if(videoDesktopPath && videoMobilePath){
                var $videoSource = $video.children("source");
                if ($(window).width() > _breakpointMedium) {
                    if($videoSource.attr("src") != videoDesktopPath){
                        $videoSource.attr("src", videoDesktopPath);
                        $video[0].load();
                        $video[0].play();

                        $video.attr("poster", imgDesktopPath);
                    }
                }
                else {
                    if($videoSource.attr("src") != videoMobilePath){
                        $videoSource.attr("src", videoMobilePath);
                        $video[0].load();
                        $video[0].play();

                        $video.attr("poster", imgMobilePath);
                    }
                }
            }
            else{
                $video.hide();
            }

            var $fallbackImg = $(this).find(".home-teaser-stage-video__image");
            if ($(window).width() > _breakpointMedium) {
                if($fallbackImg.attr("src") != imgDesktopPath){
                    $fallbackImg.attr("src", imgDesktopPath);
                }
            }
            else {
                if($fallbackImg.attr("src") != imgMobilePath){
                    $fallbackImg.attr("src", imgMobilePath);
                }
            }

            //set scroll size
            var $video = $(this).find(".home-teaser-stage-video__content");
            var $sizer = $(this).find(".home-teaser-stage-video__sizer");

            if($(this).hasClass("scrolled")){

                //set video width to container width
                var scaleFactor = $sizer.width() / $(window).width();
                $video.css("transform", "scale("+scaleFactor+")");
                
                //set video height to factor (2:3 or 16:9)
                var videoHeight = $sizer.width() * 1.5;  // 2:3
                if ($(window).width() > _breakpointMedium) {
                    videoHeight = $sizer.width() * 0.5625;  // 16:9
                }       
                $video.css("height", videoHeight + "px");

                var containerHeight = videoHeight*scaleFactor;
                if ($(window).width() > _breakpointMedium) {
                    containerHeight += 56;
                }
                else{
                    containerHeight += 48;
                }

                $(this).css("height", containerHeight + "px");
            } 
            else{
                $video.css("transform", "scale(1)");
                $video.css("height", "100vh");
            }
        
        });
    }
})(jQuery);